import React from 'react';
import Button from '../../../components/ui/Button';

const QuickActions = ({ onCreateEnquiry, onViewMessages, onViewProfile }) => {
  const actions = [
    {
      label: 'Create New Enquiry',
      description: 'Start planning your next holiday',
      icon: 'Plus',
      variant: 'default',
      onClick: onCreateEnquiry,
      primary: true
    },
    {
      label: 'View All Messages',
      description: 'Check conversations with agents',
      icon: 'MessageCircle',
      variant: 'outline',
      onClick: onViewMessages
    },
    {
      label: 'Account Settings',
      description: 'Manage your profile and preferences',
      icon: 'Settings',
      variant: 'ghost',
      onClick: onViewProfile
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-soft">
      <h2 className="text-lg font-semibold text-foreground mb-4">Quick Actions</h2>
      <div className="space-y-3">
        {actions?.map((action, index) => (
          <div
            key={index}
            className={`flex items-center justify-between p-3 rounded-lg border transition-colors ${
              action?.primary 
                ? 'border-primary/20 bg-primary/5 hover:bg-primary/10' :'border-border hover:bg-muted/50'
            }`}
          >
            <div className="flex-1">
              <h3 className="text-sm font-medium text-foreground mb-1">
                {action?.label}
              </h3>
              <p className="text-xs text-muted-foreground">
                {action?.description}
              </p>
            </div>
            
            <Button
              variant={action?.variant}
              size="sm"
              iconName={action?.icon}
              iconPosition="left"
              onClick={action?.onClick}
              className="ml-3"
            >
              {action?.primary ? 'Create' : 'View'}
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;